import { ToastContainer, toast } from 'react-toastify';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getQuizzes, getUserById } from '../utils/quiz';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Question from '../Question';
import { formatNearAmount } from 'near-api-js/lib/utils/format';
import { initializeApp } from 'firebase/app';
import { useTranslation } from 'react-i18next';
import { useWalletSelector } from '../utils/WalletSelectorContext';

const firebaseConfig = {
  apiKey: 'AIzaSyA-vn6IaYVwmo0PU5S2OyuTBcCtWD5W7e4',
  authDomain: 'quizly-7d9f8.firebaseapp.com',
  projectId: 'quizly-7d9f8',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

const QuizPage = ({ acc }) => {
  const id = window.location.pathname.split('/').pop();

  const { t, i18n } = useTranslation();

  const history = useNavigate();

  const location = useLocation();
  const isRewarded = location.state?.isRewarded;

  const [currentQuiz, setCurrentQuiz] = useState(null);
  const [currentQuestionIdx, setCurrentQuestionIdx] = useState(0);

  const [answers, setAnswers] = useState([]);
  let trueAnswers = [];

  const [submitBtnTxt, setSubmitBtnTxt] = useState(t('take-quiz-submit'));

  const { modal } = useWalletSelector();

  const handleLogin = () => modal.show();

  const handleOptionClick = (option) => {
    const newAnswers = [...answers];
    newAnswers[currentQuestionIdx] = option;
    setAnswers(newAnswers);
  };

  const handleQuizSubmit = async () => {
    if (answers.length !== currentQuiz.questions.length) {
      toast.error(
        i18n.language === 'en'
          ? 'Please answer all questions'
          : 'يرجى الإجابة على جميع الأسئلة'
      );
      return;
    }

    for (let i = 0; i < currentQuiz?.questions.length; i++) {
      trueAnswers.push(currentQuiz?.questions[i].trueHashed);
    }

    i18n.language === 'en'
      ? setSubmitBtnTxt('Submitting...')
      : setSubmitBtnTxt('جاري التسليم ...');
    const auth = getAuth();
    await signInAnonymously(auth)
      .then(async () => {
        const submitted = httpsCallable(functions, 'submit');
        await submitted({
          quizID_: id,
          sender_: acc.accountId,
          answers: answers,
          trueAns: trueAnswers,
          accId: acc.accountId,
        })
          .then((result) => {
            let resp = {};
            // console.log(result);
            if (result.data?.kind) {
              resp.status = 'error';
              resp.msg = result.data?.kind?.ExecutionError;
            } else {
              resp.status = 'success';
              resp.msg = 'Submitted successfully';
            }
            history('/result', {
              state: {
                questionsLength: currentQuiz?.questions.length,
                resultInPercent: result.data?.Result,
                percentageToWin: currentQuiz?.percentageToWin,
                isRewardGiven: result.data?.hasReceivedReward,
                rewardPerWinner: currentQuiz?.rewardPerWinner || 0,
                quizTitle: currentQuiz?.quizTitle,
                quizDescription: currentQuiz?.quizDescription,
                remainingReward: currentQuiz?.remainingReward,
                quizId: id,
                resp: resp,
                isRewarded: isRewarded,
              },
            });
            i18n.language === 'en'
              ? setSubmitBtnTxt('Submitted')
              : setSubmitBtnTxt('تم التسليم');
          })
          .catch((err) => {
            console.log(err);
            // setSubmitBtnTxt('Error');
            // toast.error('Error');
          });
      })
      .catch((err) => {
        console.log(err);
        // setSubmitBtnTxt('Error');
      });
  };

  useEffect(() => {
    // console.log(answers);
  }, [currentQuestionIdx, answers]);

  useEffect(() => {
    const fetchQuiz = async () => {
      const quizzes = await getQuizzes();
      const quiz = quizzes.filter((quiz) => quiz.quizId === id);
      // console.log(quiz[0]);
      setCurrentQuiz(quiz[0]);
    };

    fetchQuiz();
  }, [id]);

  const [user, setUser] = useState(null);

  const getUser = async () => {
    const usr = await getUserById(acc.accountId);
    return usr;
  };

  useEffect(() => {
    try {
      getUser().then((u) => setUser(u));
    } catch (e) {
      console.log(e);
    }
  }, [id]);

  const handleButtonClick = (action) => {
    if (action === 'next') {
      if (currentQuestionIdx < currentQuiz.questions.length - 1)
        setCurrentQuestionIdx(currentQuestionIdx + 1);
    } else if (action === 'prev') {
      if (currentQuestionIdx > 0) setCurrentQuestionIdx(currentQuestionIdx - 1);
    }
  };

  if (!acc.accountId)
    return (
      <div className='flex flex-col gap-4 justify-center items-center h-[75vh]'>
        <h1 className='text-4xl font-bold text-gray-700 dark:text-gray-300'>
          You are not logged in
        </h1>
        <button
          title='Login'
          onClick={handleLogin}
          className='inline-flex items-center justify-center mt-3 sm:mt-0 gap-0 py-4 px-6 text-center text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'>
          Login
        </button>
      </div>
    );

  if (
    currentQuiz &&
    new Date(currentQuiz.availableTill / 1000000).getTime() <
      new Date().getTime()
  )
    return (
      <div className='flex flex-col gap-4 justify-center items-center h-[75vh]'>
        <h1
          className='text-4xl font-bold text-gray-700 dark:text-gray-300'
          style={{ wordBreak: 'break-word' }}>
          {currentQuiz.quizTitle}
        </h1>
        <h4 className='font-semibold text-2xl'>This quiz has expired</h4>
      </div>
    );

  return (
    <main className='py-16'>
      {currentQuiz ? (
        currentQuiz?.specificUsers.includes(acc.accountId) ||
        currentQuiz?.specificUsers.length === 0 ? (
          <div className='flex flex-col items-center justify-center gap-3 max-w-3xl mx-auto'>
            <div
              className={
                i18n.language === 'en'
                  ? 'flex flex-col md:flex-row gap-2 mb-4 items-center justify-center md:text-left w-full'
                  : 'flex flex-col md:flex-row-reverse gap-2 mb-4 items-center justify-center md:text-right w-full'
              }>
              <div className='flex flex-col gap-2 mb-4 w-full'>
                <h1
                  className='text-3xl font-bold'
                  style={{ wordBreak: 'break-word' }}>
                  {currentQuiz?.quizTitle}
                </h1>
                <p className=''>{currentQuiz?.quizDescription}</p>
              </div>
              <div className='flex flex-col gap-2 mb-4 w-full'>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'></path>
                  </svg>
                  <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                    {new Date(
                      currentQuiz?.availableFrom / 1000000
                    ).toLocaleDateString(i18n.language, {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                  {i18n.language === 'ar' ? (
                    <svg
                      className='w-4 h-4 text-primary-500'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M7 16l-4-4m0 0l4-4m-4 4h18'></path>
                    </svg>
                  ) : (
                    <svg
                      className='w-4 h-4 text-primary-500'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M17 8l4 4m0 0l-4 4m4-4H3'></path>
                    </svg>
                  )}
                  <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                    {new Date(
                      currentQuiz?.availableTill / 1000000
                    ).toLocaleDateString(i18n.language, {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z'></path>
                  </svg>
                  <span>
                    {i18n.language === 'en'
                      ? `Score ${currentQuiz?.percentageToWin}% or higher to win`
                      : `أجب على ${currentQuiz?.percentageToWin}% أو أكثر للفوز`}
                  </span>
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'></path>
                  </svg>
                  {currentQuiz?.rewardPerWinner ? (
                    <span>
                      {formatNearAmount(currentQuiz?.rewardPerWinner)} NEAR
                    </span>
                  ) : (
                    <span>{formatNearAmount('0')} NEAR</span>
                  )}
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7'></path>
                  </svg>
                  {currentQuiz?.rewardPerWinner ? (
                    <span>
                      {i18n.language === 'ar' && 'عدد '}
                      {/* Comparing to self -> Checks NaN values */}
                      {formatNearAmount(currentQuiz?.remainingReward) /
                        formatNearAmount(currentQuiz?.rewardPerWinner) !==
                      formatNearAmount(currentQuiz?.remainingReward) /
                        formatNearAmount(currentQuiz?.rewardPerWinner)
                        ? 0
                        : formatNearAmount(currentQuiz?.remainingReward) /
                          formatNearAmount(currentQuiz?.rewardPerWinner)}
                      {i18n.language === 'en'
                        ? ' prize(s) left'
                        : ' جائزة متبقي'}
                    </span>
                  ) : (
                    <span>
                      {i18n.language === 'en'
                        ? 'No-prize quiz'
                        : 'اختبار بدون جائزة'}
                    </span>
                  )}
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'></path>
                  </svg>
                  <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                    {user
                      ? user.quizSubmissions.hasOwnProperty(id)
                        ? currentQuiz?.allowMultipleTrials -
                          user.quizSubmissions[id]?.submittedTimes
                        : currentQuiz?.allowMultipleTrials
                      : currentQuiz?.allowMultipleTrials}
                    {i18n.language === 'en'
                      ? ' attempt(s) left'
                      : ' محاولات متبقية'}
                  </span>
                </p>
              </div>
            </div>
            <hr className='w-full mb-4 dark:opacity-40' />
            <section
              className={`mb-3 font-mono flex gap-2 items-center justify-center ${
                i18n.language === 'ar' ? 'flex-row-reverse' : ''
              }`}>
              {currentQuiz?.questions.map((_, idx) => (
                <span
                  key={idx}
                  className={
                    currentQuestionIdx === idx
                      ? answers?.[idx]
                        ? 'border-primary-400 dark:border-primary-700 bg-primary-500 dark:bg-primary-800 p-2 rounded border-2 cursor-pointer'
                        : 'border-primary-400 dark:border-primary-700 p-2 rounded border-2 cursor-pointer'
                      : answers?.[idx]
                      ? 'p-2 rounded border-2 cursor-pointer bg-primary-500 dark:bg-primary-800 border-slate-200 dark:border-slate-700'
                      : 'p-2 rounded border-2 cursor-pointer border-slate-200 dark:border-slate-700'
                  }
                  onClick={() => setCurrentQuestionIdx(idx)}>
                  {('0' + (idx + 1)).slice(-2)}
                </span>
              ))}
            </section>
            <Question
              answer={answers[currentQuestionIdx]}
              addAnswer={handleOptionClick}
              key={currentQuiz?.questions[currentQuestionIdx].questionText}
              question={currentQuiz?.questions[currentQuestionIdx]}
            />
            <div
              className={`flex gap-3 justify-between mt-4 ${
                i18n.language === 'ar' ? 'flex-row-reverse' : ''
              }`}>
              <button
                disabled={currentQuestionIdx === 0}
                onClick={() => handleButtonClick('prev')}
                className={`font-semibold py-2 px-4 rounded ${
                  currentQuestionIdx === 0
                    ? 'cursor-not-allowed bg-gray-200 text-gray-400 dark:bg-gray-700'
                    : 'bg-primary-600 hover:bg-primary-700 text-white'
                }`}>
                {t('take-quiz-previous')}
              </button>
              {currentQuestionIdx === currentQuiz?.questions.length - 1 ? (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleQuizSubmit();
                  }}
                  className='flex items-center bg-lime-600 hover:bg-lime-700 text-white font-semibold py-2 px-4 rounded'>
                  {submitBtnTxt}
                </button>
              ) : (
                <button
                  onClick={() => handleButtonClick('next')}
                  className='bg-primary-600 hover:bg-primary-700 text-white font-semibold py-2 px-4 rounded'>
                  {t('take-quiz-next')}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            className='text-2xl my-36'>
            <h1 className='font-semibold'>
              {t('take-quiz-error-cant-access')}
            </h1>
            <h2 className='mt-2'>
              {t('take-quiz-error-cant-access-subtitle')}
            </h2>
          </div>
        )
      ) : (
        <div
          dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
          className='text-2xl my-36'>
          <h1 className='font-semibold'>{t('take-quiz-error-title')}</h1>
          <h2 className='mt-2'>{t('take-quiz-error-subtitle')}</h2>
        </div>
      )}
      <ToastContainer
        position='bottom-center'
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
    </main>
  );
};

export default QuizPage;
